import { Routes } from '@angular/router';
import { AssessmentComponent } from '../../components/assessment/assessment.component';
import { AuthenticateComponent } from '../../components/authenticate/authenticate.component';
import { ConfirmComponent } from '../../components/confirm/confirm.component';
import { ConsentComponent } from '../../components/consent/consent.component';
import { ErrorComponent } from '../../components/error/error.component';
import { InitialInformationComponent } from '../../components/initial-information/initial-information.component';
import { ResultComponent } from '../../components/result/result.component';
import { SignComponent } from '../../components/sign/sign.component';
import { WelcomeComponent } from '../../components/welcome/welcome.component';
import { assessmentReadonlyGuard } from './assessment-readonly-guard';
import { assessmentStateGuard } from './assessment-state-guard';
import { authGuard } from './auth-guard';
import { consentGuard } from './consent-guard';
import { routeGuard } from './route-guard';
import { assessmentCompletedGuard } from './assessment-completed-guard';

export const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomeComponent,
    data: {
      documentTitleRouteKey: 'document.titles.welcome',
      progress: '0%',
      isLanguageSwitchPermitted: true,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
  },
  {
    path: 'authenticate',
    component: AuthenticateComponent,
    data: {
      documentTitleRouteKey: 'document.titles.authenticate',
      progress: '14%',
      isLanguageSwitchPermitted: true,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
    canActivate: [authGuard],
  },
  { path: '', redirectTo: '/welcome', pathMatch: 'full' },
  {
    path: 'consent',
    component: ConsentComponent,
    data: {
      documentTitleRouteKey: 'document.titles.consent',
      progress: '29%',
      isLanguageSwitchPermitted: true,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
    canActivate: [routeGuard],
  },
  {
    path: 'initial-information',
    component: InitialInformationComponent,
    data: {
      documentTitleRouteKey: 'document.titles.initial-information',
      progress: '43%',
      isLanguageSwitchPermitted: false,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
    canActivate: [routeGuard, consentGuard],
  },
  {
    path: 'assessment/:assessmentId',
    component: AssessmentComponent,
    data: {
      documentTitleRouteKey: 'document.titles.assessment',
      progress: '57%',
      isLanguageSwitchPermitted: false,
      isSaveAndLogoutButtonPermitted: true,
      askSaveQuestion: true,
    },
    canActivate: [routeGuard, consentGuard, assessmentStateGuard, assessmentReadonlyGuard],
  },
  {
    path: 'confirm/:assessmentId',
    component: ConfirmComponent,
    data: {
      documentTitleRouteKey: 'document.titles.confirm',
      progress: '71%',
      isLanguageSwitchPermitted: false,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
    canActivate: [routeGuard, consentGuard, assessmentStateGuard, assessmentCompletedGuard],
  },
  {
    path: 'sign/:assessmentId',
    component: SignComponent,
    data: {
      documentTitleRouteKey: 'document.titles.sign',
      progress: '86%',
      isLanguageSwitchPermitted: false,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
    canActivate: [routeGuard, consentGuard, assessmentStateGuard],
  },
  {
    path: 'result',
    component: ResultComponent,
    data: {
      documentTitleRouteKey: 'document.titles.result',
      progress: '100%',
      isLanguageSwitchPermitted: false,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
    canActivate: [routeGuard, consentGuard, assessmentStateGuard],
  },
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      documentTitleRouteKey: 'document.titles.error',
      progress: '0%',
      isLanguageSwitchPermitted: false,
      isSaveAndLogoutButtonPermitted: false,
      askSaveQuestion: false,
    },
  },
];
